type ReplyNode = {
  replyNo?: string | number;
  upReplyNo?: string | number;
};

/**
 * 피드백(replyNo) 하위 대댓글 트리에 속하는지 여부 (깊이 제한 없음)
 */
export function isReplyUnderFeedback(
  reply: ReplyNode,
  feedbackReplyNo: string | number,
  allReplies: ReplyNode[],
) {
  if (!reply.upReplyNo) return false;

  const replyNoMap = new Map(
    allReplies.map(r => [String(r.replyNo), r]),
  );

  let currentUpReplyNo = reply.upReplyNo;
  const visited = new Set<string>();

  while (currentUpReplyNo != null && currentUpReplyNo !== '' && currentUpReplyNo !== 0) {
    const key = String(currentUpReplyNo);
    if (key === String(feedbackReplyNo)) return true;
    if (visited.has(key)) break;
    visited.add(key);

    const parent = replyNoMap.get(key);
    if (!parent) break;
    currentUpReplyNo = parent.upReplyNo;
  }

  return false;
}
